/*
  Brilinton PDP legacy feature owner - v59.
  This file replaces product-template custom-liquid scripts that previously ran inline.
  It is scoped to product pages in theme.liquid and only initializes features when their DOM exists.
*/
(function () {
  'use strict';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function debounce(fn, wait) {
    var timeout;
    return function () {
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(null, args);
      }, wait || 100);
    };
  }

  function initImageComparison(root) {
    var scope = root || document;
    var comparisons = scope.querySelectorAll('[data-component="image-comparison-slider"]');
    if (!comparisons.length) return;

    function syncCompareImageWidth(comparison) {
      var imgCompare = comparison.querySelector('.image-comparison__figure--overlay .image-comparison__image');
      var wrapper = comparison.querySelector('.image-comparison__slider-wrapper');
      if (!imgCompare || !wrapper) return;

      var rect = wrapper.getBoundingClientRect ? wrapper.getBoundingClientRect() : null;
      var width = rect && rect.width ? rect.width : wrapper.offsetWidth;
      if (!width) return;

      imgCompare.style.width = Math.round(width) + 'px';
    }

    function syncAll(scopeOverride) {
      var syncScope = scopeOverride || document;
      syncScope.querySelectorAll('[data-component="image-comparison-slider"]').forEach(function (comparison) {
        syncCompareImageWidth(comparison);
      });
    }

    function syncAfterLayout(scopeOverride) {
      var syncScope = scopeOverride || document;
      syncAll(syncScope);
      window.requestAnimationFrame(function () { syncAll(syncScope); });
      window.setTimeout(function () { syncAll(syncScope); }, 120);
      window.setTimeout(function () { syncAll(syncScope); }, 360);
    }

    function setSliderState(event, element) {
      var sliderRange = element.querySelector('[data-image-comparison-range]');
      if (!sliderRange) return;

      if (event.type === 'input') {
        sliderRange.classList.add('image-comparison__range--active');
        return;
      }

      sliderRange.classList.remove('image-comparison__range--active');
      element.removeEventListener('mousemove', moveSliderThumb);
    }

    function moveSliderThumb(event) {
      var comparison = event.currentTarget && event.currentTarget.closest ? event.currentTarget.closest('[data-component="image-comparison-slider"]') : null;
      if (!comparison) return;

      var sliderRange = comparison.querySelector('[data-image-comparison-range]');
      var thumb = comparison.querySelector('[data-image-comparison-thumb]');
      if (!sliderRange || !thumb) return;

      var rect = sliderRange.getBoundingClientRect ? sliderRange.getBoundingClientRect() : null;
      var pointerY = rect ? event.clientY - rect.top : event.layerY;
      var position = pointerY - 20;
      if (pointerY <= 0) position = -20;
      if (pointerY >= sliderRange.offsetHeight) position = sliderRange.offsetHeight - 20;
      thumb.style.top = position + 'px';
    }

    function moveSliderRange(event, element) {
      var value = event.target.value;
      var slider = element.querySelector('[data-image-comparison-slider]');
      var imageWrapperOverlay = element.querySelector('[data-image-comparison-overlay]');

      if (slider) slider.style.left = value + '%';
      if (imageWrapperOverlay) imageWrapperOverlay.style.width = value + '%';

      element.addEventListener('mousemove', moveSliderThumb);
      setSliderState(event, element);
      syncAfterLayout(element);
    }

    comparisons.forEach(function (comparison) {
      var sliderRange = comparison.querySelector('[data-image-comparison-range]');
      if (!sliderRange) {
        syncCompareImageWidth(comparison);
        return;
      }

      syncCompareImageWidth(comparison);

      if (!comparison.dataset.comparisonResizeBound && 'ResizeObserver' in window) {
        comparison.dataset.comparisonResizeBound = 'true';
        var resizeObserver = new ResizeObserver(function () {
          syncCompareImageWidth(comparison);
        });
        var wrapper = comparison.querySelector('.image-comparison__slider-wrapper');
        if (wrapper) resizeObserver.observe(wrapper);
      }

      comparison.querySelectorAll('img').forEach(function (image) {
        if (image.dataset.comparisonLoadBound === 'true') return;
        image.dataset.comparisonLoadBound = 'true';
        image.addEventListener('load', function () { syncAfterLayout(comparison); });
      });

      if (sliderRange.dataset.comparisonBound === 'true') return;
      sliderRange.dataset.comparisonBound = 'true';

      if (!('ontouchstart' in window)) {
        sliderRange.addEventListener('mouseup', function (event) { setSliderState(event, comparison); });
        sliderRange.addEventListener('mousedown', moveSliderThumb);
      }

      sliderRange.addEventListener('input', function (event) { moveSliderRange(event, comparison); });
      sliderRange.addEventListener('change', function (event) { moveSliderRange(event, comparison); });
    });

    syncAfterLayout(scope);
  }

  function initProductSpecsDefaults(root) {
    var scope = root || document;
    var roots = scope.querySelectorAll('[data-br-product-specs]');
    if (!roots.length) return;

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    roots.forEach(function (specRoot) {
      var details = Array.prototype.slice.call(specRoot.querySelectorAll('[data-b1-spec-accordion], [data-b1-mobile-detail]'));
      if (!details.length) return;
      var defaultDetail = specRoot.querySelector('[data-default-open-desktop]') || details[0];

      if (!isMobile() && defaultDetail && !details.some(function (detail) { return detail.open; })) {
        defaultDetail.open = true;
      }

      if (specRoot.dataset.specsDefaultsBound === 'true') return;
      specRoot.dataset.specsDefaultsBound = 'true';

      details.forEach(function (detail) {
        detail.addEventListener('toggle', function () {
          if (isMobile() || !detail.hasAttribute('data-default-open-desktop')) return;
          if (detail.open) return;
          window.requestAnimationFrame(function () {
            if (!details.some(function (node) { return node.open; })) detail.open = true;
          });
        });
      });
    });
  }

  function initSliderProgress() {
    var sliderSelector = '.product__media-list';
    var sliderElement = document.querySelector(sliderSelector);
    if (!sliderElement) return;

    var slides = document.querySelectorAll(sliderSelector + ' .product__media-item.slider__slide');
    var totalSlides = slides.length;
    if (!totalSlides) return;

    var progressBar = document.querySelector('#progressBar');
    var slideCounter = document.querySelector('#slideCounter');
    var nextButton = document.querySelector('.slider-button--next');
    var prevButton = document.querySelector('.slider-button--prev');
    var currentIndex = 0;

    function updateProgressBarAndCounter(index) {
      if (progressBar) {
        progressBar.style.width = (((index + 1) / totalSlides) * 100) + '%';
      }
      if (slideCounter) {
        slideCounter.innerText = (index + 1) + ' / ' + totalSlides;
      }
    }

    var handleScroll = debounce(function () {
      var width = sliderElement.offsetWidth || 1;
      var newIndex = Math.round(sliderElement.scrollLeft / width);
      newIndex = Math.max(0, Math.min(newIndex, totalSlides - 1));
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        updateProgressBarAndCounter(currentIndex);
      }
    }, 100);

    sliderElement.addEventListener('scroll', handleScroll);

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        currentIndex = Math.min(currentIndex + 1, totalSlides - 1);
        updateProgressBarAndCounter(currentIndex);
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        currentIndex = Math.max(currentIndex - 1, 0);
        updateProgressBarAndCounter(currentIndex);
      });
    }

    updateProgressBarAndCounter(currentIndex);
  }

  function initProductPopup() {
    var productPopup = document.querySelector('button.open_popup_product');
    var popup = document.querySelector('#product-popup');
    if (!productPopup || !popup) return;

    function togglePopup() {
      popup.classList.toggle('show');
    }

    productPopup.addEventListener('click', togglePopup);

    var productPopupOverlay = popup.querySelector('.overlay');
    if (productPopupOverlay) productPopupOverlay.addEventListener('click', togglePopup);

    var productPopupClose = popup.querySelector('.close-popup');
    if (productPopupClose) productPopupClose.addEventListener('click', togglePopup);
  }

  function initMobileMediaGalleryMove() {
    var mediaGallery = document.querySelector('media-gallery.product__column-sticky');
    var mainContent = document.getElementById('MainContent');
    if (!mediaGallery || !mainContent) return;

    var originalParent = mediaGallery.parentElement || document.querySelector('.product__media-wrapper');
    var originalNextSibling = mediaGallery.nextSibling;

    function moveMediaGallery() {
      var isMobile = window.matchMedia('(max-width: 989px)').matches;

      if (isMobile) {
        if (mainContent.previousElementSibling !== mediaGallery) {
          mainContent.insertAdjacentElement('beforebegin', mediaGallery);
        }
        return;
      }

      if (originalParent && mediaGallery.parentElement !== originalParent) {
        if (originalNextSibling && originalNextSibling.parentElement === originalParent) {
          originalParent.insertBefore(mediaGallery, originalNextSibling);
        } else {
          originalParent.appendChild(mediaGallery);
        }
      }
    }

    setTimeout(moveMediaGallery, 250);
    window.addEventListener('resize', debounce(moveMediaGallery, 120));
  }

  function initStickyAddToCart() {
    var stickyBtn = document.getElementById('custom-add-to-cart');
    var realBtn = document.querySelector('.product-form__submit');
    if (!stickyBtn || !realBtn) return;

    function isDisabled(el) {
      if (!el) return true;
      if (el.tagName === 'BUTTON') return el.disabled;
      if (el.tagName === 'A') {
        return el.hasAttribute('disabled') || el.getAttribute('aria-disabled') === 'true' || el.classList.contains('disabled') || el.classList.contains('is-disabled');
      }
      return false;
    }

    function syncButtonState(isRealButtonVisible) {
      if (typeof isRealButtonVisible === 'boolean') {
        stickyBtn.classList.toggle('hidden', isRealButtonVisible);
      }

      if (isDisabled(realBtn)) {
        stickyBtn.setAttribute('disabled', 'disabled');
        stickyBtn.classList.add('disabled');
      } else {
        stickyBtn.removeAttribute('disabled');
        stickyBtn.classList.remove('disabled');
      }

      var text = realBtn.textContent && realBtn.textContent.trim();
      if (text) stickyBtn.textContent = text;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          syncButtonState(entry.isIntersecting);
        });
      });
      observer.observe(realBtn);
    } else {
      syncButtonState(false);
    }

    var mutationObserver = new MutationObserver(function () {
      syncButtonState();
    });
    mutationObserver.observe(realBtn, { attributes: true, childList: true, characterData: true, subtree: true });

    stickyBtn.addEventListener('click', function (event) {
      if (isDisabled(realBtn)) {
        event.preventDefault();
        return;
      }

      if (realBtn.tagName === 'BUTTON') {
        realBtn.click();
      } else if (realBtn.tagName === 'A' && realBtn.href) {
        window.location.href = realBtn.href;
      }
    });
  }

  function initFlickitySliders() {
    if (typeof window.Flickity === 'undefined') return;

    var elem = document.querySelector('.multi-slider_container');
    if (elem && !elem.classList.contains('b1-flickity-initialized')) {
      elem.classList.add('b1-flickity-initialized');
      new window.Flickity(elem, {
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        wrapAround: true,
        percentPosition: true
      });
    }

    var popupSlider = document.querySelector('.slick-slider');
    var progressBar = document.getElementById('progressBar_slick');
    if (popupSlider && progressBar && !popupSlider.classList.contains('b1-flickity-initialized')) {
      popupSlider.classList.add('b1-flickity-initialized');
      var flktyPopup = new window.Flickity(popupSlider, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: true,
        percentPosition: true
      });

      function updateProgressBar() {
        var totalSlides = flktyPopup.slides.length || 1;
        var currentIndex = flktyPopup.selectedIndex + 1;
        progressBar.style.width = ((currentIndex / totalSlides) * 100) + '%';
      }

      flktyPopup.on('change', updateProgressBar);
      updateProgressBar();
    }
  }

  function initMulticolumnPopups() {
    document.addEventListener('click', function (event) {
      var columnPopup = event.target.closest('button.multicolumn-card_opener');
      if (!columnPopup) return;

      var card = columnPopup.parentElement && columnPopup.parentElement.parentElement;
      if (card) card.classList.toggle('active');
    });
  }

  function initMulticolumnTabs() {
    var multiTabs = document.querySelectorAll('.multicolumn-tab');
    if (!multiTabs.length) return;

    multiTabs.forEach(function (section) {
      var tabButtons = section.querySelectorAll('.tab');
      var tabParents = section.querySelectorAll('[data-tab-parent]');

      if (tabButtons.length > 0 && tabParents.length > 0) {
        var defaultTabButton = tabButtons[0];
        var defaultTargetTab = defaultTabButton.getAttribute('data-tab');
        var defaultParent = section.querySelector('[data-tab-parent="' + defaultTargetTab + '"]');

        defaultTabButton.classList.add('active');
        if (defaultParent) defaultParent.classList.add('active', 'fade-in');
      }

      tabButtons.forEach(function (tabButton) {
        tabButton.addEventListener('click', function () {
          var targetTab = tabButton.getAttribute('data-tab');
          var isActive = tabButton.classList.contains('active');

          tabButtons.forEach(function (button) { button.classList.remove('active'); });
          tabParents.forEach(function (parent) { parent.classList.remove('active', 'fade-in'); });

          if (!isActive) {
            tabButton.classList.add('active');
            var targetParent = section.querySelector('[data-tab-parent="' + targetTab + '"]');
            if (targetParent) targetParent.classList.add('active', 'fade-in');
          }
        });
      });
    });
  }

  function initResponsiveMulticolumnMedia() {
    var elements = document.querySelectorAll('.multicolumn-without__media');
    if (!elements.length) return;

    var originalPositions = Array.prototype.map.call(elements, function (element) {
      var parent = element.parentElement;
      var index = parent ? Array.prototype.indexOf.call(parent.children, element) : -1;
      return { element: element, parent: parent, index: index };
    }).filter(function (item) {
      return item.parent;
    });

    function handleResize() {
      var isSmallDevice = window.innerWidth < 749;

      originalPositions.forEach(function (item) {
        var element = item.element;
        var parent = item.parent;
        var index = item.index;

        if (isSmallDevice) {
          if (element.parentElement === parent && parent.parentElement) {
            parent.parentElement.insertBefore(element, parent);
          }
        } else if (element.parentElement !== parent) {
          var referenceElement = parent.children[index] || null;
          parent.insertBefore(element, referenceElement);
        }
      });
    }

    handleResize();
    window.addEventListener('resize', debounce(handleResize, 120));
  }

  function initVideoCards() {
    var posters = document.querySelectorAll('.video-section__poster');

    posters.forEach(function (poster, index) {
      setTimeout(function () {
        if (typeof poster.click === 'function') poster.click();

        if (index === posters.length - 1) {
          posters.forEach(function (p) {
            var videoElement = p.nextElementSibling && p.nextElementSibling.nextElementSibling;
            if (videoElement && typeof videoElement.play === 'function') {
              videoElement.play().catch(function () {});
            }
          });
        }
      }, index * 50);
    });

    var videoPlayElements = document.querySelectorAll('.multicolumn-card_video_play');
    videoPlayElements.forEach(function (element) {
      element.addEventListener('click', function () {
        var video = element.parentElement && element.parentElement.querySelector('video');
        var videoButton = element.parentElement && element.parentElement.querySelector('.video-section__poster');

        if (video) {
          if (video.paused) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }

          video.addEventListener('play', function () { element.classList.add('active'); });
          video.addEventListener('pause', function () { element.classList.remove('active'); });
        } else if (videoButton) {
          videoButton.click();
          element.classList.add('active');
        }
      });
    });
  }

  function initVariantHoverLabels() {
    document.querySelectorAll('variant-selects').forEach(function (variantSelect) {
      var productFormInputPill = variantSelect.querySelector('.product-form__input--pill');
      if (!productFormInputPill) return;

      var selectedValue = productFormInputPill.querySelector('[data-selected-value]');
      productFormInputPill.querySelectorAll('input[type=radio]').forEach(function (radio) {
        if (radio.classList.contains('disabled')) return;
        var label = radio.nextElementSibling;
        if (!label) return;

        label.addEventListener('mouseenter', function () {
          if (!selectedValue) return;
          selectedValue.dataset.defaultValue = selectedValue.innerText;
          selectedValue.innerText = label.innerText;
        });

        label.addEventListener('mouseleave', function () {
          if (selectedValue && selectedValue.dataset.defaultValue) {
            selectedValue.innerText = selectedValue.dataset.defaultValue;
          }
        });
      });
    });
  }

  function initRecentlyViewedProduct() {
    var productId = document.querySelector('[data-product-id]') && document.querySelector('[data-product-id]').getAttribute('data-product-id');
    if (!productId || !window.localStorage) return;

    try {
      var recentlyViewedRaw = localStorage.getItem('recentlyViewed');
      var recentlyViewed = recentlyViewedRaw ? JSON.parse(recentlyViewedRaw) : [];
      if (!Array.isArray(recentlyViewed)) recentlyViewed = [];

      if (recentlyViewed.indexOf(productId) === -1) {
        recentlyViewed.unshift(productId);
        if (recentlyViewed.length > 10) recentlyViewed.pop();

        var save = function () {
          localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
        };

        if ('requestIdleCallback' in window) {
          requestIdleCallback(save);
        } else {
          save();
        }
      }
    } catch (error) {
      // LocalStorage can be blocked in some privacy modes. Ignore safely.
    }
  }

  onReady(function () {
    initImageComparison();
    initProductSpecsDefaults();
    window.addEventListener('resize', debounce(function () {
      initImageComparison();
      initProductSpecsDefaults();
    }, 120));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        window.setTimeout(function () {
          initImageComparison();
          initProductSpecsDefaults();
        }, 80);
      });
    }
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(debounce(function () {
        initImageComparison();
        initProductSpecsDefaults();
      }, 80));
      observer.observe(document.body, { childList: true, subtree: true });
    }
    initSliderProgress();
    initProductPopup();
    initMobileMediaGalleryMove();
    initStickyAddToCart();
    initFlickitySliders();
    initMulticolumnPopups();
    initMulticolumnTabs();
    initResponsiveMulticolumnMedia();
    initVideoCards();
    initVariantHoverLabels();
    initRecentlyViewedProduct();
  });
})();
